<template>
  <div class="container">
    <h1>Mein Name ist Katharina Herda</h1>

    <div class="highlight-blockquote katharina-herda" aria-label="Portrait: Katharina Herda">
          <div class="highlight-blockquote-text-container">
            <p class="quote">
              einfühlsam, herzlich, respektvoll und reflektiert
            </p>
          </div>
    </div>

        <!-- <img src="../assets/img/kathi-quer.jpg" width="600" alt="Portrait: Katharina Herda" /> -->

    <p>Es ist mir ein Anliegen ein Umfeld zu schaffen, in dem sich Mensch &amp; Tier auf körperlicher 
      und seelischer Ebene vertrauensvoll öffnen können. Beide Ebenen vereine ich in der Craniosacralen 
      Energiebalance und meiner Tätigkeit als Rednerin.</p>

    <h2>Mein Weg zur Craniosacralen Energiebalance</h2>
    <img src="../assets/img/ueber-mich/kathi-mit-janosch-800x480.jpg" width="800" alt="Katharina Herda mit ihrem Pferd Janosh" />

    <p>Der tägliche Umgang mit Tieren stellt seit meiner Kindheit einen festen Bestandteil in meinem Leben dar. 
      Von ihnen durfte ich von klein auf ein liebvolles und respektvolles Miteinander erlernen. Auf dieser 
      Basis widmete ich mich als Montessoripädagogin ganz der Förderung der individuellen Entwicklung von 
      Menschen. Der Respekt vor der Einzigartigkeit jedes Individuums hat mich stets begleitet.</p>

    <p>Desweiteren lernte ich in meiner Motopädagogik-Ausbildung feinste motorische Veränderungen des Körpers 
      zu erkennen und therapeutisch zu nutzen. Fasziniert von den Erfolgen der Craniosacralen Arbeit bei 
      meinen Kindern, entschloss ich mich 2012 diesen Weg für mich vollständig einzuschlagen und absolvierte 
      die mehrjährige Ausbildung der Craniosacralen Energiebalance für Mensch und Tier bei Ute Pfersmann im 
      Pferdezentrum Eichthal.</p>

    <p>Mein Wille mich laufend fortzubilden und zu verbessern führt mich regelmäßig an neue Themen heran. 
      So fließen Kenntnisse aus der Kinesologie, Isopathie, Orthobionomie und Biomechanik mit in die Arbeit 
      ein.</p>

    <p>Zur Zeit beschäftige ich mich intensiv mit der NCMT-Therapie von Johannes Randolf, einer 
      Therapiemethode zur klaren Ursachenbestimmung und effizienten Behandlung vor allem bei chronischen 
      Schmerzen und Dysbalancen.</p>
    
    <p>Ich genieße den Austausch mit gleichgesinnten TherapeutInnen um neue Wege zu suchen und zu definieren, 
      aneinander zu üben und uns gegenseitig zu coachen. So unterstützen wir einander nicht in Altbewährtem 
      hängen zu bleiben und uns ständig weiter zu entwickeln.<p>
    
    <p><router-link :to="{ path: 'energiebalance' }" class="block margin-tb align-right">Mein Angebot der Craniosacralen Energiebalance</router-link> </p>

    
    <h2>Mein Weg als Rednerin</h2>
    <img src="../assets/img/ueber-mich/trauerreden-800x480.jpg" width="800" alt="Katharina Herda vor dem Bestattungssaal" />

    <p>Es war der Tod meiner Mutter, der mich veranlasst hat, sich mit dieser Thematik zu befassen. Das 
      Bedürfnis den Menschen, sein Wesen, seine Stärken und Schwächen bei dieser letzten Feier, die wir für
       einen Menschen ausrichten, dem Begräbnis oder der Beisetzung, ins Wort zu bringen.</p>

    <p>Den Schwerpunkt nicht nur auf den Verlust und den Schmerz zu legen, sondern auf darauf, wer dieser 
      Mensch war und welche Ereignisse uns verbunden oder auch getrennt haben. So schrieb ich meinen ersten 
      Nachruf für meine Mutter, nicht wissend was sich daraus für mich entwickeln wird.</p>

    <p>Ich tauchte ein in die Welt unserer und anderer Begräbniskulturen und der Auseinandersetzung mit dem 
      Tod. Es entstand das Bedürfnis die Geschichten zu erzählen, die hinter den Menschen stehen, die von 
      uns gehen.</p>
      
    <p>Ein Bekannter bat mich etwas über seine Mutter zu schreiben, sie war aus der Kirche ausgetreten und 
      so wäre eine kirchliche Verabschiedung für ihn unpassend gewesen. Ich unterhielt mich mit Freunden 
      und Verwandten über diese Frau und erfasste meinen ersten Nachruf, für einen Menschen den ich nicht 
      persönlich kannte. Der Bestatter kam nach dem Begräbnis zu mir und fragte mich, ob ich das 
      Hauptberuflich mache. Diese Frage brachte mich darauf diese Idee weiter zu verfolgen und umzusetzen.</p>
      
    <p>Heute erzähle ich mit großer Freude Lebensgeschichten von Menschen, die von uns gegangen sind, ob alt 
      oder jung, herzlich und liebenswert oder schwierig, eigenbrödlerisch. Jeder Mensch hat seine ganz 
      persönliche Geschichte, seine ganz eigenen Erfahrungen, ist seinen speziellen Weg gegangen – all diesen 
      Ereignissen, Erfahrungen, Erlebnissen eine sehr persönliche Stimme zu geben, ist mir zu einer 
      Herzensangelegenheit geworden.</p>

    <p>Viele unterschiedliche Familien durfte ich bisher begleiten und unterstützen einen würdevollen, 
      persönlichen Abschied zu gestalten. Eine Feier in einem Garten, weil der Verstorbene sich der Anatomie 
      vermacht hat, im Rahmen einer Bootsfahrt, weil die Asche in die Donau gestreut wurde, in einem Ruhewald, 
      weil sich jemand auch nach dem Tod die Nähe zur Natur gewünscht hat, gemeinsam mit Geistlichen im Rahmen 
      einer katholischen Verabschiedung, Sternenkinder, Suizide,...</p>

    <p>Das Vertrauen, dass mir von so vielen Menschen entgegengebracht wurde und wird, berührt mich immer 
      wieder aufs Neue. So vielfältig das Leben ist, so vielfältig sind die Geschichten, die ich erfahren, 
      schreiben und vortragen darf.</p>

    <p>Mit viel Empathie, Diskretion und Respekt führe ich die Gespräche, nähere ich mich den Menschen und 
      ihrer Persönlichkeit an und erarbeite einen authentischen würdevollen Text, helfe bei der Auswahl 
      passender Musikstücke, gestalte, gemeinsam mit den Bestattern ein letztes Fest für jene Menschen die 
      von uns gegangen sind und in unseren Herzen und unserer Erinnerung eine neue Bleibe gefunden haben.</p>
    
        <p><router-link :to="{ path: 'trauerreden' }" class="block margin-tb align-right">Mein Angebot als Rednerin</router-link> </p>

    <div class="highlight-blockquote trauerreden-urne">
      <div class="highlight-blockquote-text-container">
      <blockquote >
        <p>
          „Im Abschied liegt die Geburt der Erinnerung"
        </p>
        - Khalil Gibran
      </blockquote>
      </div>
    </div>
    <!-- <img src="../assets/img/trauerreden-urne-800x480.png" width="800" alt="Urne in einem Kranz am Schiff aufgebahrt" /> -->

  </div>
</template>

<script>
export default {
  name: "About", //this is the name of the component
  metaInfo() {
      return { 
          title: "Über mich - Katharina Herda",
          meta: [
            { name: 'description', content: 'Katharina Herda lebt ihren Beruf. Als einfühlsame, herzliche und respektvolle Person geht sie individuell auf die Bedürfnisse ihrer Klienten ein. Durch ihre unkonventionelle Art findet sie immer Lösungen.' },
            { property: 'og:title', content: "Über mich - Katharina Herda"},
            { property: 'og:description', content: 'Katharina Herda lebt ihren Beruf. Als einfühlsame, herzliche und respektvolle Person geht sie individuell auf die Bedürfnisse ihrer Klienten ein. Durch ihre unkonventionelle Art findet sie immer Lösungen.'}, 
            { property: 'og:image', content: 'src/img/assets/ueber-mich/kathi.jpg'},
            { property: 'og:url', content: 'www.herda.at/uebermich'}

          ]
      }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/About.vue